export function scheduleNonCriticalTask(callback, timeout = 1200) {
  if (typeof window === 'undefined') {
    return null
  }

  if (typeof window.requestIdleCallback === 'function') {
    return {
      type: 'idle',
      id: window.requestIdleCallback(callback, { timeout }),
    }
  }

  return {
    type: 'timeout',
    id: window.setTimeout(callback, timeout),
  }
}

export function cancelNonCriticalTask(taskHandle) {
  if (!taskHandle || typeof window === 'undefined') {
    return
  }

  if (
    taskHandle.type === 'idle' &&
    typeof window.cancelIdleCallback === 'function'
  ) {
    window.cancelIdleCallback(taskHandle.id)
    return
  }

  if (taskHandle.type === 'timeout') {
    window.clearTimeout(taskHandle.id)
  }
}
